﻿<template>
  <div>
    <table-list
      title="题库列表"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="questionStoreList"
      :btns="btns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :options="{ selection: true, operatesWidth: 360 }"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <!-- 创建题库 -->
    <el-dialog
      title="创建题库"
      :visible.sync="createVisible"
      width="420px"
      :close-on-click-modal="false"
      @closed="$refs.createForm && $refs.createForm.resetFields()"
    >
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="createRules"
        label-width="80px"
        @submit.native.prevent
      >
        <el-form-item label="题库名称" prop="questionStoreName">
          <el-input
            v-model="createForm.questionStoreName"
            maxlength="50"
            placeholder="请输入题库名称"
            @keyup.enter.native="handleCreate"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="createVisible = false">取 消</el-button>
        <el-button type="primary" :loading="createLoading" @click="handleCreate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改题库名称 -->
    <el-dialog
      title="修改题库名称"
      :visible.sync="renameVisible"
      width="420px"
      :close-on-click-modal="false"
      @closed="$refs.renameForm && $refs.renameForm.resetFields()"
    >
      <el-form
        ref="renameForm"
        :model="renameForm"
        :rules="renameRules"
        label-width="80px"
        @submit.native.prevent
      >
        <el-form-item label="题库名称" prop="questionStoreName">
          <el-input
            v-model="renameForm.questionStoreName"
            maxlength="50"
            placeholder="请输入题库名称"
            @keyup.enter.native="handleRename"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="renameVisible = false">取 消</el-button>
        <el-button type="primary" :loading="renameLoading" @click="handleRename">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入试题 -->
    <el-dialog
      title="导入试题"
      :visible.sync="importVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <el-upload
        ref="importUpload"
        action=""
        accept=".xls,.xlsx"
        :limit="1"
        :file-list="fileList"
        :before-upload="beforeImportUpload"
        :http-request="importQuestion"
        :on-remove="() => (fileList = [])"
        :on-exceed="handleFileExceed"
      >
        <el-button type="primary">试题导入</el-button>
        <div slot="tip" class="el-upload__tip">仅支持 .xls / .xlsx 文件，大小不超过 10MB</div>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '创建题库',
    icon: 'el-icon-circle-plus-outline',
    method: _this.handleOpenCreate,
  },
  {
    label: '下载导入模板',
    icon: 'el-icon-document',
    method: _this.handleDownloadTemp,
  },
  {
    label: '导出试题',
    icon: 'el-icon-document',
    method: _this.handleExportQues,
  },
]
// 搜索框配置
const searchForm = () => [
  {
    label: '题库名称',
    prop: 'questionStoreName',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'questionStoreName',
    label: '题库名称',
    minWidth: 200,
  },
  {
    prop: 'questionTypeMuster',
    label: '试题包含类型',
    minWidth: 160,
    formatter: row => _this.formatQuestionTypes(row.questionTypeMuster),
  },
  {
    prop: 'questionNum',
    label: '题目数量',
    minWidth: 100,
    sortdata: 1,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 150,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleDetail,
    label: '查看详情',
  },
  {
    method: _this.handleOpenRename,
    label: '编辑题库',
  },
  {
    method: _this.handleEditQuestion,
    label: '编辑试题',
  },
  {
    method: _this.handleImport,
    label: '导入试题',
  },
  {
    method: _this.deleteFn,
    label: '删除',
  },
]
// 题型编码转换（1-单选 2-多选 3-计算 4-判断 5-填空 6-简答 ...）
const questionTypeMap = {
  1: '单选题',
  2: '多选题',
  3: '计算题',
  4: '判断题',
  5: '填空题',
  6: '简答题',
  7: '论述题',
  8: '案例分析题',
  9: '综合题',
}
import TableList from '@/components/TableList'
import {
  questionStorePage,
  questionStoreRename,
  questionStoreCreate,
  questionStoreImport,
  questionStoreTempDownload,
  questionStoreDelete,
  storeQuestionExport,
} from '@/api/exam'
import to from 'await-to'
export default {
  name: 'QuestionStore',
  components: {
    TableList,
  },
  data() {
    return {
      searchForm,
      btns,
      columns,
      operates,
      loading: false,
      questionStoreList: [],
      // 已勾选的题库
      selectStoreList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      // 创建题库
      createVisible: false,
      createLoading: false,
      createForm: {
        questionStoreName: '',
      },
      createRules: {
        questionStoreName: [
          { required: true, message: '请输入题库名称', trigger: 'blur' },
          { max: 50, message: '题库名称不能超过 50 个字符', trigger: 'blur' },
        ],
      },
      // 修改题库名称
      renameVisible: false,
      renameLoading: false,
      renameForm: {
        id: '',
        questionStoreName: '',
      },
      renameRules: {
        questionStoreName: [
          { required: true, message: '请输入题库名称', trigger: 'blur' },
          { max: 50, message: '题库名称不能超过 50 个字符', trigger: 'blur' },
        ],
      },
      // 导入试题
      importStoreId: '',
      importVisible: false,
      fileList: [],
    }
  },
  mounted() {
    this.getQuestionStore()
  },
  methods: {
    // 多选
    handleSelectionChange(val) {
      this.selectStoreList = val
    },
    async handleExportQues() {
      console.log('选中的题库数据：', this.selectStoreList)
      if (this.selectStoreList.length === 0) return this.$message.error('请选择题库')
      let arr = []
      if (this.selectStoreList.length) this.selectStoreList.map(v => arr.push(v.questionStoreId))
      const [res, err] = await to(
        storeQuestionExport({
          storeIdList: arr,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '题库试题.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleEditQuestion(row) {
      this.$router.push({
        path: '/exam/questionStore/design',
        query: { id: row.questionStoreId, name: row.questionStoreName },
      })
    },
    deleteFn(row) {
      this.$confirm('确定删除该题库吗？', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning',
      }).then(async () => {
        const [, err] = await to(
          questionStoreDelete({
            questionStoreIds: [row.questionStoreId],
          }),
        )
        if (err) return this.$message.warning(err.msg)
        this.$message.success('删除成功')
        this.getQuestionStore()
      })
    },
    formatQuestionTypes(value) {
      if (!value) return '-'
      return String(value)
        .split(',')
        .map(item => questionTypeMap[item] || item)
        .join(',')
    },
    async getQuestionStore() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(questionStorePage({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.questionStoreList = res.data.list
      this.pager.total = res.data.total
    },
    // 查询/重置
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getQuestionStore()
    },
    // 创建题库
    handleOpenCreate() {
      this.createVisible = true
    },
    async handleCreate() {
      const valid = await this.$refs.createForm.validate().catch(() => false)
      if (!valid) return
      if (this.createLoading) return
      this.createLoading = true
      const [, err] = await to(questionStoreCreate(this.createForm))
      this.createLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('创建成功')
      this.createVisible = false
      this.pager.current = 1
      this.getQuestionStore()
    },
    // 打开修改题库名称弹窗
    handleOpenRename(row) {
      this.renameForm.id = row.questionStoreId
      this.renameForm.questionStoreName = row.questionStoreName
      this.renameVisible = true
    },
    // 修改题库名称
    async handleRename() {
      const valid = await this.$refs.renameForm.validate().catch(() => false)
      if (!valid) return
      if (this.renameLoading) return
      this.renameLoading = true
      const [, err] = await to(questionStoreRename(this.renameForm))
      this.renameLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('修改成功')
      this.renameVisible = false
      this.getQuestionStore()
    },
    // 下载导入模板
    async handleDownloadTemp() {
      const [res, err] = await to(questionStoreTempDownload())
      if (err) return this.$message.error(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '题库导入模板.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 查看详情
    handleDetail(row) {
      this.$router.push({
        path: '/exam/questionStore/detail',
        query: { id: row.questionStoreId, name: row.questionStoreName },
      })
    },
    // 导入试题
    handleImport(row) {
      this.importStoreId = row.questionStoreId
      this.fileList = []
      this.importVisible = true
    },
    // 导入校验：仅支持 xls/xlsx 且不超过 10MB
    beforeImportUpload(file) {
      const isExcel = /\.(xls|xlsx)$/i.test(file.name)
      if (!isExcel) {
        this.$message.warning('仅支持 .xls / .xlsx 格式文件')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 <= 10
      if (!isLt10M) {
        this.$message.warning('上传文件大小不能超过 10MB')
        return false
      }
      return true
    },
    // 超出数量限制时替换已选文件
    handleFileExceed(files) {
      this.$refs.importUpload.clearFiles()
      const file = files[0]
      if (file) this.$refs.importUpload.handleStart(file)
    },
    async importQuestion(file) {
      const params = new FormData() //创建FormData
      params.append('file', file.file)
      params.append('questionStoreId', this.importStoreId)
      const [, err] = await to(questionStoreImport(params))
      this.fileList = []
      if (err) return this.$message.warning(err.msg)
      this.$message({
        message: '导入成功',
        type: 'success',
      })
      this.importVisible = false
      this.getQuestionStore()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getQuestionStore()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getQuestionStore()
    },
  },
}
</script>
